import * as React from 'react';

import { observer } from 'mobx-react';

import { Button } from '@estee/elc-buttons';
import { Heading3 } from '@estee/elc-typography';

import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/RampService';
import {
    formClassName,
    formSubtitleClassName,
    formTitleClassName,
    formWrapperClassName
} from '~utils/Classes';
import { useTranslation } from '~utils/hooks/translations';
import { DynamicForm } from '~views/common/DynamicForm';
import { MessagePanel } from '~views/common/MessagePanel';

import { ResetPasswordFormViewController } from './ResetPasswordFormViewController';

export const ResetPasswordForm = observer(() => {
    const {
        data: { formStore, sendToText = '', passwordValidations, schema, errorMessages },
        savePasswordAndSignInClicked
    }: ResetPasswordFormViewController = diContainer.get(
        serviceNames.resetPasswordFormViewController
    );

    const {
        resetPasswordSubtitle,
        resetPasswordNewPassword,
        savePasswordAndSignIn,
        loadingLabel
    } = useTranslation();

    const { isSubmitting } = formStore;

    return (
        <div className={formWrapperClassName}>
            <MessagePanel messages={errorMessages} />
            <Heading3 className={formTitleClassName}>{resetPasswordNewPassword}</Heading3>
            <p className={formSubtitleClassName}>
                <span
                    dangerouslySetInnerHTML={{
                        __html: resetPasswordSubtitle?.replace('::OTP_CONTACT::', sendToText)
                    }}
                />
            </p>
            <div className={formClassName}>
                <DynamicForm
                    name="resetPassword"
                    formSchema={schema}
                    validations={passwordValidations}
                    formStore={formStore}
                    className={formClassName}
                    submit={savePasswordAndSignInClicked}
                />
            </div>
            <Button disabled={isSubmitting} onClick={savePasswordAndSignInClicked}>
                {isSubmitting ? loadingLabel : savePasswordAndSignIn}
            </Button>
        </div>
    );
});
